<button class="td-wb-date-picker-toggle"
        id="datePickerOpenCalendarButton"
        [disabled]="disabled"
        [attr.aria-label]="'tdWb.datePicker.OPEN_CALENDAR' | tdWbTranslate"
        tdWbIconButton
        tdWbIconButtonSize="small"
        tdWbIconButtonShape="circle"
        tdWbIconButtonBackground="clear-tint"
        type="button"
        [tdWbOverlayToggle]="calendar.content"
        tdWbOverlayPosition="end-center">
  <td-wb-icon class="td-wb-date-picker-toggle__icon" iconId="calendar--small" size="18" />
</button>
